import { render, staticRenderFns } from "./superAdd.vue?vue&type=template&id=62db70a4&scoped=true"
import script from "./superAdd.vue?vue&type=script&lang=js"
export * from "./superAdd.vue?vue&type=script&lang=js"
import style0 from "./superAdd.vue?vue&type=style&index=0&id=62db70a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62db70a4",
  null
  
)

export default component.exports